module.exports = __webpack_public_path__ + "35e71ee66f0063d8849a074e54457833.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-30.png
// module id = 2194
// module chunks = 0